import { getSsrContext } from './ssrRequestContext';

interface SsrLogParams {
  url: string;
  timing: number;
  status: number;
  auth?: boolean;
  error?: string;
}

/**
 * Logs a single SSR fetch request in the standard format:
 * [id] [page:phase] fetch [url] timing=[N]ms status=[N] auth=[bool] [error=[msg]]
 *
 * Silent when called outside an SSR request context.
 */
export function logSsrFetch(params: SsrLogParams): void {
  const ctx = getSsrContext();
  if (!ctx) return;

  const { url, timing, status, auth, error } = params;

  const parts: string[] = [
    `[${ctx.pageId}]`,
    `page:type=[${ctx.page}]`,
    `url=[${url}]`,
    `timing=[${Math.round(timing)}ms]`,
    `status=[${status}]`,
  ];

  if (auth !== undefined) parts.push(`auth=[${auth}]`);
  if (error !== undefined) parts.push(`error=[${error}]`);

  console.info(parts.join(' '));
}
